import { ISyncOptions } from '@/utils/ISyncOptions';
import { syncOperation, sync } from '@/utils/PersistentStore';
import { messageService } from '@/utils/MessageService';
import { areaSaggioPiantaCampioneStore, TABLES } from './store/areaSaggioPiantaCampione.store';
import { areaSaggioPiantaCampioneService } from './services/areaSaggioPiantaCampioneService';

export default {
  startup: async (): Promise<void> => {
    await areaSaggioPiantaCampioneStore.getters.getAll();
  },
  syncOperations: async (): Promise<void> => {
    await sync<server.areaSaggioPiantaCampione>(TABLES.areaSaggioPiantaCampione,
      i => syncOperation.create, i => areaSaggioPiantaCampioneService.Set(i, i.versioneId), i => areaSaggioPiantaCampioneService.Set(i, i.versioneId),
      async (o, n, op) => {
        messageService.publish('updateMediaReference', { type: 'areaSaggioPiantaCampione', oldTypeId: o.id, newTypeId: n.id } as messages.updateMediaReference);
      })
  }
} as ISyncOptions;